import React from 'react';
import classNames from 'classnames';
import { bool, string, oneOf } from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import './HtmlParser.scss';

function sanitizedHtml(html) {
  if (!html || typeof html !== 'string') return '';
  const regex = /(\s(sizes|id|style|class|width|height)+=".*?")|(<script.*?>.*?<\/script>)|(<style.*?>.*?<\/style>)/gm;
  return html.replace(regex, '');
}

const HtmlParser = ({
  htmlString, sanitized, display, className,
}) => (
  <span
    className={classNames({ 'html-parser': true }, className)}
    style={{ display }}
  >
    {ReactHtmlParser(sanitized ? sanitizedHtml(htmlString) : htmlString)}
  </span>
);

HtmlParser.defaultProps = {
  htmlString: '',
  sanitized: false,
  display: 'inline',
  className: '',
};

HtmlParser.propTypes = {
  htmlString: string,
  sanitized: bool,
  display: oneOf(['block', 'inline', 'inline-block']),
  className: string,
};

export default HtmlParser;
